import { render, staticRenderFns } from "./confirmPopup.vue?vue&type=template&id=23bc6e1c&scoped=true"
import script from "./confirmPopup.vue?vue&type=script&lang=js"
export * from "./confirmPopup.vue?vue&type=script&lang=js"
import style0 from "./confirmPopup.vue?vue&type=style&index=0&id=23bc6e1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc6e1c",
  null
  
)

export default component.exports